export default {
  STORE_CONTENT: 'STORE_CONTENT',
  STORE_ARTICLE: 'STORE_ARTICLE',
};
